<script setup>
import { ref, computed } from "vue";
import { Inertia } from '@inertiajs/inertia';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head, usePage } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import {
    mdiPlusCircle
} from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import TableFilter from "@/Components/TableFilter.vue";
import Buttons from "@/Components/Buttons.vue";
import PremiumPageHeader from "@/Components/PremiumPageHeader.vue";
import PremiumTabs from "@/Components/PremiumTabs.vue";
import Dropdown from "@/Components/Dropdown.vue";
import DropdownLink from "@/Components/DropdownLink.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import BreezeInput from '@/Components/Input.vue';

const props = defineProps({
    datalist: [Array, Object],
    columnas: [Array, Object],
    freeday_types: [Array, Object],
    isAdmin: Boolean,
    canRead: Boolean,
    canWrite: Boolean,
    userParam: [Array, Object],
    statusOptions: [Array, Object],
    useFilterAnio: Number,
    entidades: [Object, Array]
});

const rutaPrefijo = ref('freeday');
const modulo = ref('freeday');
const title = ref('Días Libres'); // <-- Descripción en la parte superior de la tabla
const tab = ref(0);

//console.log(props.columnas)

// Now date
let now = new Date();
let month = (now.getMonth() + 1);
let day = now.getDate();
if (month < 10)
    month = "0" + month;
if (day < 10)
    day = "0" + day;
let today = now.getFullYear() + '-' + month + '-' + day;

const dateNow = ref(today);

/**
 * Table filter
 */
const page = usePage();
const user = computed(() => page.props.value.auth.user);
const isAdmin = computed(() => user.value.id_rol <= 4);

const mapOptions = (obj) => {
    if (!obj) return undefined;
    if (Object.keys(obj).length === 0) return undefined;
    return Object.entries(obj).map(([key, value]) => ({
        value: isNaN(key) ? key : Number(key),
        label: value
    }));
};

// Mostrar entidades en días libres // <-- Cuando hay mas de una empresa
const hasEntidad = computed(() => {
    if (!props.entidades) return false;
    return Array.isArray(props.entidades) ? props.entidades.length > 1 : Object.keys(props.entidades).length > 1;
});

const columns = computed(() => {
    const baseColumns = [
        { key: 'actions', label: 'Acciones' },
    ];

    if (hasEntidad.value) {
        baseColumns.push({ key: 'entity', label: 'Entidad', filterType: 'select', filterOptions: mapOptions(props.entidades) });
    }

    if (isAdmin.value) {
        baseColumns.push(
            //{ key: 'id', label: 'ID', align: 'center' },
            { key: 'apellidos', label: 'Apellidos', fieldType: 'linkobject' },
            { key: 'nombres', label: 'Nombres' },
            { key: 'id_freeday_type', label: 'Tipo', filterType: 'select', filterOptions: mapOptions(props.freeday_types) },
            { key: 'fecha_inicio', label: 'Fecha Inicio', filterType: 'date' },
            { key: 'fecha_fin', label: 'Fecha Fin', filterType: 'date' },
            { key: 'description', label: 'Descripción' },
            { key: 'detalle_cancelacion', label: 'Rechazo' },
            { key: 'autor_name', label: 'Autor' },
            { key: 'status', label: 'Estado', filterType: 'select', filterOptions: mapOptions(props.statusOptions), filterColor: [{ value: -1, color: 'gray' }, { value: 0, color: 'red' }, { value: 1, color: 'green' }], align: 'center' }
        );
    } else {
        baseColumns.push(
            { key: 'apellidos', label: 'Apellidos', fieldType: 'linkobject' },
            { key: 'nombres', label: 'Nombres' },
            { key: 'id_freeday_type', label: 'Tipo', filterType: 'select', filterOptions: mapOptions(props.freeday_types) },
            { key: 'fecha_inicio', label: 'Fecha Inicio', filterType: 'date' },
            { key: 'fecha_fin', label: 'Fecha Fin', filterType: 'date' },
            { key: 'description', label: 'Descripción' },
            { key: 'detalle_cancelacion', label: 'Rechazo' },
            { key: 'status', label: 'Estado', filterType: 'select', filterOptions: mapOptions(props.statusOptions), filterColor: [{ value: -1, color: 'gray' }, { value: 0, color: 'red' }, { value: 1, color: 'green' }], align: 'center' }
        );
    }

    return baseColumns;
});

const massaction = ref('');
const isProcessingMassAction = ref(false);
const massiveFieldValue = ref('');
const massiveFieldValue2 = ref('');
const massiveFieldValue3 = ref('');

const executeMassAction = async (selectedItems, clearSelection, notify) => {
    const arrayitemschecks = selectedItems.map(item => item.id); // <-- Id de objeto para la acción masiva

    let id_select1 = null;
    let id_select2 = null;
    let id_select3 = null;
    let id_select4 = null;

    if (massaction.value === 'changeSelect1') {
        id_select1 = massiveFieldValue.value;
    } else if (massaction.value === 'changeSelect2') {
        id_select2 = massiveFieldValue.value;
    } else if (massaction.value === 'changeSelect3') {
        id_select3 = massiveFieldValue.value;
    } else if (massaction.value === 'changeSelect4') {
        id_select4 = massiveFieldValue.value;
    }

    const formMassAction = {
        'action': massaction.value,
        'cr': arrayitemschecks,
        'modulo': modulo.value,
        'origin_type': '',
        'field_value': massiveFieldValue.value,
        'field_value2': massiveFieldValue2.value,
        'field_value3': massiveFieldValue3.value,
        'id_select1': id_select1,
        'id_select2': id_select2,
        'id_select3': id_select3,
        'id_select4': id_select4,
    };

    isProcessingMassAction.value = true;
    try {
        const response = await axios.put('/' + rutaPrefijo.value + '/massaction', formMassAction);
        const respuesta = response.data;
        if (respuesta.success) {
            notify(respuesta.message || 'Registros actualizados correctamente', 'success');
            clearSelection();
            massaction.value = '';
            massiveFieldValue.value = '';
            Inertia.reload({ only: ['datalist'] });
        } else {
            notify(respuesta.message || 'Error al procesar la acción masiva', 'danger');
        }
    } catch (error) {
        console.error(error);
        notify('Ocurrió un error en el servidor.', 'danger');
    } finally {
        isProcessingMassAction.value = false;
    }
};

/**
 * Cargar archivos
 */

const titleDoc = ref('')
const arrayDocumentos = ref([]);
const arrayDocumentosCol = ref([]);
const srcObjectId = ref(0)

const tabsMenu = computed(() => {
    let tabs = [
        { id: 0, label: 'Listado', icon: 'tabler:list', show: true }
    ];
    if (tab.value === 2) {
        tabs.push({ id: 2, label: 'Documentos', icon: 'tabler:file-description', show: true });
    }
    return tabs;
});

const switchTab = (id) => {
    tab.value = id;
    if (id === 0) {
        srcObjectId.value = 0;
    }
};
const listarDocumentos = (src_object_id) => {
    srcObjectId.value = src_object_id
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/document/file_document_freeday?src_object_id=' + src_object_id;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayDocumentos.value = respuesta.datalist;
        arrayDocumentosCol.value = respuesta.columnas;
        //console.log(arrayDocumentos.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const inputFileName = ref('')
const inputFileDesc = ref('')
const inputFilePos = ref(1)
const showInputFile = ref(false)
const fileDocument = ref(null)
const fileSize = ref(0)
const documentNotify = ref(false) // Notifación por correo
const changeFile = (type) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    let file = null;
    if (type == 'file_document_freeday') {
        file = fileDocument.value.files[0];
    }

    // FIX error Failed to set the 'value' property on 'HTMLInputElement'
    if (file) {
        fileSize.value = file.size
        if (file.name.includes('.jpg') || file.name.includes('.png')) {
            console.log('Es imagen')
        } else {
            console.log('No es imagen jpg o png')
        }

        // Rellenar input name
        let fileName = file.name
        let nameSinExtension = fileName.replace(/\.[^/.]+$/, "")
        inputFileName.value = nameSinExtension

        //console.log(inputFileName.value);
        console.log(file.size);
    }

}

const uploadFile = (type, origin_id = 0) => {
    let data = new FormData()
    let file = null;
    let notify = documentNotify.value
    if (type == 'file_document_freeday') {
        file = fileDocument.value.files[0];
        origin_id = srcObjectId.value
    }
    data.append('file', file)
    data.append('origin_type', type)

    // Se puede agregar otro origin id si fuera necesario
    data.append('origin_id', origin_id)

    data.append('name', inputFileName.value)
    data.append('description', inputFileDesc.value)
    data.append('position', inputFilePos.value)
    data.append('notify', notify)
    console.log(file)
    axios.post('/file/upload', data)
        .then(response => {

            if (response.data.error) {
                if (type == 'file_document_freeday') {
                    errorMessage.value == response.data.message
                }
            } else if (response.data.success) {
                listarDocumentos(srcObjectId.value)
                cleanInputFile()

            }
            console.log(response.data)
        })
        .catch(error => {
            console.log(error)
        })

}

const cleanInputFile = () => {
    inputFileName.value = ''
    inputFileDesc.value = ''
    inputFilePos.value = 1
    fileDocument.value = null
    fileSize.value = 0
}

</script>

<template>

    <Head title="Días Libres" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PremiumPageHeader 
                title="Justificación de faltas" 
                subtitle="Registro y control de permisos, inasistencias y días libres." 
                icon="tabler:calendar-cancel" 
                color="indigo"
                :actionsOnBottomOnMobile="false"
            >
                <template #actions>
                    <Buttons 
                        v-if="tab == 0"
                        label="Nuevo Registro" 
                        icon="f7:plus-app-fill" 
                        size="vuexy" 
                        color="blue" 
                        :href="route(rutaPrefijo + '-create')" 
                        hideLabelOnMobile 
                    />
                </template>
                <template #bottom>
                    <PremiumTabs :modelValue="tab" @change="switchTab($event.id)" :tabs="tabsMenu" />
                </template>
            </PremiumPageHeader>
        </template>
        <div>
            <template v-if="tab == 0">
                <div class="bg-white overflow-hidden shadow-lg border rounded-md p-4">
                    <CardBox v-if="columnas.length" has-table>
                        <!-- Tablesingle opciones: checkable opción para cambiar precio sería dentro -->
                        <div class="w-full relative">
                            <!-- <TableAdvanced :modulo="modulo" :modulos="modulos" :userParam="userParam" :data="datalist" :fields="columnas" :ruta="rutaPrefijo" exporteable searchAdvance :checkable="(isAdmin ? true : false)" :massDelete="(isAdmin ? true : false)" :isSearchYear="(isAdmin ? true : false)" />-->

                            <TableFilter :data="datalist" :columns="columns" :title="title" :ruta="rutaPrefijo" :modulo="modulo" :userParam="userParam" top-scrollbar manage-columns :checkable="(isAdmin ? true : false)" exporteable :processing="isProcessingMassAction" :useFilterAnio="useFilterAnio" defaultSort="fecha_inicio" defaultOrder="desc">
                                <template #mass-actions="{ selectedItems, clearSelection, requestConfirm, notify }">
                                    <div class="flex flex-col md:flex-row sm:items-center gap-3 p-1 w-full xl:w-auto">
                                        <select v-model="massaction" class="w-full xl:w-auto" :disabled="isProcessingMassAction">
                                            <option value="" disabled>Acción masiva...</option>

                                            <option v-if="props.isAdmin" value="freedayaprobar">Aprobar solicitudes</option>
                                            <option v-if="props.isAdmin" value="freedaydesaprobar">En espera de aprobación</option>
                                            <option v-if="props.isAdmin" value="freedaycancelar">Cancelar Solicitudes</option>
                                            <option v-if="props.isAdmin" value="freedaychangedate">Cambiar Fecha Inicio - Fin</option>
                                            <option v-if="props.isAdmin" value="eliminar">Eliminar seleccionado</option>
                                        </select>
                                        <div v-if="massaction === 'freedaycancelar'" class="w-full xl:w-auto">
                                            <input type="text" v-model="massiveFieldValue" placeholder="Motivo del rechazo (Opcional)" class="w-full sm:min-w-[175px]">
                                        </div>
                                        <div v-if="massaction === 'freedaychangedate'" class="w-full xl:w-auto">
                                            <input type="date" v-model="massiveFieldValue" title="Fecha de Inicio" class="w-full sm:min-w-[175px]">
                                            <input type="date" v-model="massiveFieldValue2" title="Fecha de Fin" class="w-full sm:min-w-[175px]">
                                        </div>

                                        <!-- Confirmar -->
                                        <div class="flex w-full xl:w-auto gap-2">
                                            <Buttons @click="!massaction ? alert('Por favor, selecciona una acción masiva.') : requestConfirm(`¿Está seguro de aplicar esta acción masiva a los <b>${selectedItems.length}</b> seleccionados?`, () => executeMassAction(selectedItems, clearSelection, notify))" color="blue" size="sm" class="flex-1 justify-center whitespace-nowrap" :class="{ 'opacity-50 cursor-not-allowed': (!massaction || isProcessingMassAction) }">
                                                <i class="fa-solid" :class="isProcessingMassAction ? 'fa-spinner fa-spin' : 'fa-check'"></i>
                                                <span class="ml-1">Confirmar</span>
                                            </Buttons>
                                            <Buttons @click="clearSelection(); massaction = ''" color="red" size="sm" class="flex-1 justify-center whitespace-nowrap" :disabled="isProcessingMassAction">
                                                <i class="fa-solid fa-xmark"></i>
                                                <span class="ml-1">Cancelar</span>
                                            </Buttons>
                                        </div>
                                    </div>
                                </template>
                                <template #cell-actions="{ item }">
                                    <div class="flex flex-row justify-center gap-2">
                                        <!-- <Buttons :href="route(rutaPrefijo + '-show', { id: item.id })" size="iconSm" color="primary" title="Ver">
                                                <i class="fa-light fa-eye"></i>
                                            </Buttons> -->
                                        <Dropdown align="leftRight" width="48">
                                            <template #trigger>
                                                <Buttons size="iconSm" color="light" title="Ver">
                                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                                </Buttons>
                                            </template>
                                            <template #content>
                                                <div class="px-2 py-1 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b mb-1">
                                                    Acciones
                                                </div>
                                                <!-- <DropdownLink :href="route(rutaPrefijo + '-show', { id: item.id })" class="flex items-center gap-2">
                                                        <i class="fa-light fa-eye text-gray-700"></i>
                                                        <span>Ver Ficha</span>
                                                    </DropdownLink> -->
                                                <div @click="(tab = 2, listarDocumentos(item.id), (titleDoc = item.apellidos + ' ' + item.nombres + ' - ' + item.fecha_inicio))" class="flex items-center gap-2 w-full px-4 py-2 text-left text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out">
                                                    <i class="fa-light fa-eye text-gray-700"></i>
                                                    <span>Ver documentos</span>
                                                </div>
                                            </template>
                                        </Dropdown>
                                    </div>
                                </template>
                            </TableFilter>
                        </div>
                    </CardBox>
                    <CardBox v-else>
                        <CardBoxComponentEmpty />
                    </CardBox>
                </div>
            </template>
            <template v-if="tab == 2">
                <div class="bg-white overflow-hidden shadow-lg border rounded-md p-4">
                    <h3 class="mb-3">Documentos adjuntos <span class="text-blue-600">{{ titleDoc }}</span></h3>
                    <!-- <div v-if="message">{{ message }}</div> -->
                    <div v-if="canWrite" class="">
                        <p class="my-2 text-sm mb-3">
                            Puede subir archivos PDF, DOCX, PPT, XLSX, JPG,
                            PNG, con un <b>límite máximo</b> de {{
                                confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE }}
                            KB. <b>Si ingresa un nombre que ya existe el documento anterior será reemplazado por este</b>.
                        </p>
                        <div v-if="fileSize > (1000 * parseInt(confGlobal.value.DOCUMENT_LIMIT_UPLOAD_FILE))" class="mb-4">
                            <small class="font-medium text-red-600">El archivo
                                supera
                                el tamaño límite permitido</small>
                        </div>
                        <div class="mb-4">
                            <label>
                                <input id="file_document_freeday" ref="fileDocument" type="file" @change="changeFile('file_document_freeday')" class="w-full" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS">
                            </label>
                        </div>
                        <div class="mb-4 w-full">
                            <label for="name" class="text-sm mb-1">Nombre de Archivo </label>
                            <BreezeInput id="inputname" type="text" class="mt-1 block w-full" v-model="inputFileName" required />
                        </div>
                        <div class="mb-4">
                            <label for="desc" class="text-sm mb-1">Descripción (opcional) </label>
                            <textarea id="inputdesc" type="text" class="mt-1 block w-full" v-model="inputFileDesc" autocomplete="off"> </textarea>
                        </div>

                        <!-- <div class="col-span-1 no-number mb-4">
                                <label for="documentNotify" class="text-sm mb-1" data-title="Si el servicio de notificación está habilitada se enviará un mensaje al adminsitrador">Notificar al administrador </label>
                                <input id="documentNotify" name="documentNotify" type="checkbox" class="" v-model="documentNotify">
                            </div> -->

                        <BaseButton :icon="mdiPlusCircle" color="info" icon-size="20" small label="Guardar" @click="uploadFile('file_document_freeday')" class="btn btn-blue px-8 lg:w-auto w-full" />
                    </div>
                    <hr class="my-4">
                    <!-- Lista -->
                    <div class="w-full overflow-x-auto relative">
                        <CardBox v-if="arrayDocumentos.length" class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <TableAdvanced modulo="Documento" modulos="Documentos" :data="arrayDocumentos" :fields="arrayDocumentosCol" ruta="file" :deleteable="true" originType="file_document_freeday" :originId="srcObjectId" @reload="listarDocumentos(srcObjectId)" />
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
                    </div>
                </div>
            </template>
        </div>

    </BreezeAuthenticatedLayout>
</template>
